import type { CampaignComparableModel, CampaignModel } from '@models/types'

type BuildCampaignComparableParams = {
  campaign: CampaignModel,
  comparable: CampaignComparableModel,
}

function buildCampaignComparable(params: BuildCampaignComparableParams) {
  const { campaign, comparable } = params

  const campaignComparable = {
    address: comparable.address,
    auction_date: comparable.auction_date,
    bathrooms: comparable.bathrooms,
    bedrooms: comparable.bedrooms,
    building_area: comparable.building_area,
    campaign_id: campaign.id,
    carparks: comparable.carparks,
    comparable_source: comparable.comparable_source || 'market',
    country_code: comparable.country_code,
    distance: comparable.distance,
    image_url: comparable.image_url,
    land_area: comparable.land_area,
    latitude: comparable.latitude,
    listing_agency: comparable.listing_agency,
    listing_agent: comparable.listing_agent,
    longitude: comparable.longitude,
    post_code: comparable.post_code,
    price: comparable.price,
    price_guide: comparable.price_guide,
    property_type: comparable.property_type,
    rpd: comparable.rpd,
    sale_type: comparable.sale_type,
    sold: comparable.sold,
    sold_date: comparable.sold_date,
    source_campaign_id: comparable.comparable_source === 'agency' ? comparable.id : null,
    state_name: comparable.state_name,
    street_name: comparable.street_name,
    street_number: comparable.street_number,
    suburb_name: comparable.suburb_name,
    unit_number: comparable.unit_number,
    data: {
      data_provider: {
        title: comparable.data_provider,
        entity_id: comparable.id,
      },
    },
  }

  // @ts-expect-error TS2339
  if (comparable.rental) campaignComparable.data.sale_method = 'rental'

  return campaignComparable
}

export default buildCampaignComparable
